import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlFormatterService {

  formatUserIdForUrl(userId: string): string {
    return btoa(userId).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  }

  parseUserIdFromUrl(hash: string): string {
    const base64 = hash.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    return atob(base64 + padding);
  }
}
